import React, { ReactElement } from 'react';

import FilterChecklist from '@buyside/components/presentation/Filters/FilterChecklist/filterChecklist';
import FilterSelect from '@buyside/components/presentation/Filters/FilterSelect/filterSelect';
import SelectableDropdown from '@buyside/components/presentation/SelectableDropdown/selectableDropdown';

import { labelizedFilterListOptions } from '@buyside/components/presentation/Filters/filterUtil';

const {
  assetClasses,
  cities,
  fundTypes,
  compCategories,
  compTitles,
  cashCompRanges,
  yearsOfExperience,
  yearSubmitted,
  fundSizes,
  compFundStrategies,
  compIndustries
} = labelizedFilterListOptions;

const CompensationIndexFilters = (): ReactElement => (
  <>
    <SelectableDropdown title="Category">
      <FilterChecklist filterList={compCategories} paramName="category" />
    </SelectableDropdown>
    <SelectableDropdown title="Role">
      <FilterChecklist filterList={compTitles} paramName="comp_title" />
    </SelectableDropdown>
    <SelectableDropdown title="City" overflowVisible>
      <FilterSelect options={cities} paramName="comp_location" />
    </SelectableDropdown>
    <SelectableDropdown title="Comp Range">
      <FilterChecklist filterList={cashCompRanges} paramName="total_cash_comp_range" />
    </SelectableDropdown>
    <SelectableDropdown title="Years of Experience">
      <FilterChecklist filterList={yearsOfExperience} paramName="years_of_exp" />
    </SelectableDropdown>
    <SelectableDropdown title="Year Submitted" overflowVisible>
      <FilterSelect paramName="year_submitted" options={yearSubmitted} />
    </SelectableDropdown>
    <SelectableDropdown title="Fund Size">
      <FilterChecklist filterList={fundSizes} paramName="comp_fund_size" />
    </SelectableDropdown>
    <SelectableDropdown title="Firm Type">
      <FilterChecklist filterList={fundTypes} paramName="comp_fund_type" />
    </SelectableDropdown>
    <SelectableDropdown title="Fund Strategy">
      <FilterChecklist filterList={compFundStrategies} paramName="comp_fund_strategy" />
    </SelectableDropdown>
    <SelectableDropdown title="Industry Focus">
      <FilterChecklist filterList={compIndustries} paramName="comp_industry" />
    </SelectableDropdown>
    <SelectableDropdown title="Asset Class Expertise">
      <FilterChecklist filterList={assetClasses} paramName="comp_asset_class" />
    </SelectableDropdown>
  </>
);

export default CompensationIndexFilters;
